import { useQuery } from '@tanstack/react-query';
import { ROUTES, type Carrier, type CarrierRate } from '@serb/shared';
import { api } from '../../api/client';
import { useVaultRecords } from '../claudeTasks/useVaultRecords';

/** The shipping lines and airlines, read from the Serb Mind vault */
export const useCarriers = () => useVaultRecords<Carrier>('carriers', 'Carrier', () => api.get(ROUTES.api.carriers));

/** The rates carriers were named on, from the vault's agent quotes (Data/quotes.csv) */
export const useCarrierRates = () => {
  const q = useQuery({ queryKey: ['carrier-rates'], queryFn: () => api.get<CarrierRate[]>(ROUTES.api.carrierRates) });
  return q.data ?? [];
};
